import { Injectable } from '@angular/core';

import { Session } from './session';
import { ComplianceFeatureFlagService } from '@services/feature-flags/compliance';

import { isEmbeddedWebView } from '../lib/boot-utils';

export interface IWebViewFeature {
  name: string;
  canLoad: (appExperience: AppExperienceService) => boolean;
}

export const webViewFeatures: IWebViewFeature[] = [
  {
    name: 'team-driver',
    canLoad: (appExperience: AppExperienceService) => appExperience.isTeamDrivingExperience(),
  },
];

@Injectable({
  providedIn: 'root',
})
export class AppExperienceService {
  constructor(
    private sessionService: Session,
    private complianceFeatureFlagService: ComplianceFeatureFlagService,
  ) { }

  public isTeamDrivingExperience() {
    return this.sessionService.isDriver()
      && this.complianceFeatureFlagService.isTeamDrivingEnabled()
      && isEmbeddedWebView();
  }
}
